import VerificationChecklistAPI from '@/api/verification-checklist.api'
import NotesAPI from '@/api/notes.api'

const state = {
  accountChecklistItems: [],

  accountIdentityCheck: {}
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {
  
}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  async getAccountChecklistItems({ commit }, accountId) {
    const response = await VerificationChecklistAPI.getAccountChecklistItems(accountId)

    commit('SET_ACCOUNT_CHECKLIST_ITEMS', response.data)

    return response.data
  },

  async getAccountRepresentativeIdentityCheck({ commit }, accountId) {
    const response = await VerificationChecklistAPI.getAccountRepresentativeIdentityCheck(accountId)

    commit('SET_ACCOUNT_IDENTITY_CHECK', response.data)

    return response.data
  },

  async uploadChecklistDocument({ dispatch, rootGetters, state }, { checklistItemId, noteListId, file }) {
    const accountId = rootGetters['auth/accountId']

    const checklistItem = Array.isArray(state.accountChecklistItems)
      ? state.accountChecklistItems.find(item => item && item.id === checklistItemId)
      : null

    const checklistItemName =
      checklistItem && checklistItem.checklistItemDetails && checklistItem.checklistItemDetails.name
        ? checklistItem.checklistItemDetails.name
        : 'Document'

    const description = checklistItemName + ' was uploaded by client'

    // 1. Upload file and create review note
    await NotesAPI.addReviewNotes({
      noteListId,
      parentObjectId: checklistItemId,
      description,
      attachment: file
    })

    // 2. Update status to Received (only reached if upload succeeded)
    await VerificationChecklistAPI.markChecklistItemReceived(accountId, checklistItemId)

    // 3. Refresh checklist items
    await dispatch('getAccountChecklistItems', accountId)
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_ACCOUNT_CHECKLIST_ITEMS(state, accountChecklistItems) {
    state.accountChecklistItems = accountChecklistItems
  },

  SET_ACCOUNT_IDENTITY_CHECK(state, accountIdentityCheck) {
    state.accountIdentityCheck = accountIdentityCheck
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}